import React from "react";
import style from "./index.module.scss";
import classNames from "classnames";

interface ListItemSimpleProps {
    name: string;
    studentNo: string;
    status: React.ReactNode;
}

export default function ListItemSimple({
    name,
    studentNo,
    status
}: ListItemSimpleProps) {
    return (
        <div className={style.root}>
            <div className={style.left}>
                <div className={style.name} title={name}>
                    {name}
                </div>
                <div className={style.stuNo}>{studentNo}</div>
            </div>

            <div className={classNames(style.status)}>{status}</div>
        </div>
    );
}
